module.exports = __webpack_public_path__ + "assets/1-NYC-Tech-Sales-Jobs.8b821e86.png";